module.exports = __webpack_public_path__ + "img/catalogo-digital.7dcc7910.svg";